module.exports = __webpack_public_path__ + "27dd317c6ca6bd399164317677799105.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/studio1.jpg
// module id = 195
// module chunks = 0